export default __webpack_public_path__ + "static/media/IndustrySector_Background.f207c564.svg";